module.exports = __webpack_public_path__ + "img/route-17-nissan.e78ae9d5.png";